var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Delete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.778 2.222v10.805c0 .955-.796 1.729-1.778 1.729H4c-.982 0-1.778-.774-1.778-1.73V2.223M0 2.222L16 2.222",
    transform: "translate(-448 -175) translate(448 175) translate(0 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 2.222H5.333V.89c0-.49.399-.889.89-.889h3.555c.49 0 .889.398.889.889v1.333zM8 4.444L8 12.444M10.667 4.444L10.667 12.444M5.333 4.444L5.333 12.444",
    transform: "translate(-448 -175) translate(448 175) translate(0 .667)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Delete);
export default __webpack_public_path__ + "static/media/ico16Delete.1cd45678.svg";
export { ForwardRef as ReactComponent };